<template>
  <div>
    <div id="content">
      <el-row>
        <el-col :span="12"
          ><div class="dleft">
            <div class="anl">
              <el-input
                v-model="keyword"
                placeholder="QuestionID"
                clearable
                size="small"
                style="width: 184px; margin-right: 115px"
              ></el-input>
              <el-button type="info" plain size="small" @click="selectAll"
                ><i class="el-icon-check"></i>全选</el-button
              ><el-button type="info" plain size="small" @click="valueQid = []"
                ><i class="el-icon-close"></i>全不选</el-button
              ><el-button
                size="small"
                type="primary"
                @click="add"
                :loading="loading"
                ><i class="el-icon-plus"></i>添加</el-button
              >
            </div>
            <div>
              <el-cascader-panel
              ref="cascaderPanel" 
                v-model="valueQid"
                :options="optionsFil"
                :props="{ multiple: true, emitPath: false }"
              ></el-cascader-panel>
            </div>
            <div class="weizhi" v-if="weiShow">
                  <p>multi 类型需要选取匹配的题型</p>
                  <el-radio-group v-model="wei">
                    <div class="radio-with-image">
                      <span class="thumbnail-container">
                        <img class="thumbnail" :src="getThumbnail('1')" @click="showImage('1')" alt="Option 1示意图">
                      </span>
                      <el-radio label="1" border>
                        适用于：品牌带入题干，single、grid有无loop均可
                      </el-radio>
                    </div>
                    <div class="radio-with-image">
                      <span class="thumbnail-container">
                        <img class="thumbnail" :src="getThumbnail('2')" @click="showImage('2')" alt="Option 2示意图">
                      </span>
                      <el-radio label="2" border>
                        适用于：Questionid相同带loop，loop句子
                      </el-radio>
                    </div>
                    <div class="radio-with-image">
                      <span class="thumbnail-container">
                        <img class="thumbnail" :src="getThumbnail('3')" @click="showImage('3')" alt="Option 3示意图">
                      </span>
                      <el-radio label="3" border>
                        适用于：Questionid相同带loop，loop品牌
                      </el-radio>
                    </div>
                    <div class="radio-with-image">
                      <span class="thumbnail-container">
                        <img class="thumbnail" :src="getThumbnail('4')" @click="showImage('4')" alt="Option 4示意图">
                      </span>
                      <el-radio label="4" border>
                        适用于：QuestionId不同，句子选品牌
                      </el-radio>
                    </div>
                  </el-radio-group>
                  
                  <!-- 图片预览对话框 -->
                  <el-dialog
                    :visible.sync="imageDialogVisible"
                    :modal-append-to-body="true"
                    width="70%"
                    top="5vh"
                    center
                    custom-class="image-preview-dialog"
                  >
                    <div style="text-align: center;">
                      <img :src="currentImage" style="width: 100%; height: auto; max-height: 70vh; object-fit: contain;" />
                    </div>
                  </el-dialog>
            </div>
            </div
        ></el-col>
        <el-col :span="12"
          ><div class="dright" v-show="configs.length > 0">
            <div class="anl">
              <span style="font-size: 13px; color: #afafaf"
                >已创建组合表格，共 {{ configs.length }} 个</span
              >
              <el-button
                type="danger"
                plain
                size="mini"
                round
                style="margin-left: 16px"
                :loading="clearLoading"
                @click="clearAll"
              ><i class="el-icon-delete"></i>清除</el-button>
            </div>
            <el-table
              :data="configs"
              style="width: 100%; margin-top: 20px"
              stripe
              border
              size="mini"
            >
              <el-table-column
                prop="qid"
                label="组合ID"
                width="200"
              ></el-table-column>
              <el-table-column
                prop="tpe"
                label="题型"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="wei"
                label="类型"
                width="120"
              ></el-table-column>
              <el-table-column label="操作" width="180">
                <template #default="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    plain
                    round
                    @click="preview(scope.row, scope.$index)"
                    ><i class="el-icon-view"></i>预览</el-button
                  >
                  <el-button
                    type="danger"
                    size="mini"
                    plain
                    round
                    @click="tagDel(scope.$index, scope.row.id)"
                    ><i class="el-icon-delete"></i>删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div></el-col
        >
      </el-row>
    </div>

    <!-- 预览弹窗 -->
    <el-dialog
      title="组合表预览"
      :visible.sync="previewDialogVisible"
      width="92%"
      top="2vh"
      :modal-append-to-body="true"
      @mousedown.native="cancelEdit"
    >
      <div class="preview-table-wrap" v-if="previewHeads.length > 0">
        <div class="preview-table-center">
        <table class="preview-table" cellspacing="0" cellpadding="0">
          <thead>
            <tr ref="headerLabelRow">
              <th class="side-header" rowspan="2">Label</th>
              <th class="side-header" rowspan="2">Code</th>
              <th v-for="(h, i) in previewHeads" :key="'label-'+i"
                class="data-col drag-col"
                :title="h.Label"
                :style="{ minWidth: isEditingHead(i) ? '200px' : '' }">
                <div class="col-header-inner" :style="{ minWidth: isEditingHead(i) ? '200px' : '' }">
                  <i class="el-icon-rank drag-handle" title="拖拽排序"></i>
                  <el-input
                    v-if="isEditingHead(i)"
                    v-model="h.Label"
                    size="mini"
                    @blur="endEditHead(i)"
                    @keyup.enter="endEditHead(i)"
                    @mousedown.native.stop
                    ref="headInput" + i
                    autofocus
                  ></el-input>
                  <span v-else class="col-content" @click="startEditHead(i)">{{ h.Label }}</span>
                </div>
                <i class="el-icon-close col-del" @click.stop="delCol(i)" title="删除此列"></i>
              </th>
            </tr>
            <tr>
              <th v-for="(h, i) in previewHeads" :key="'code-'+i" class="data-col code-row" :title="h.Code">{{ h.Code }}</th>
            </tr>
          </thead>
          <tbody ref="previewTbody">
            <tr v-for="(s, j) in previewSides" :key="'row-'+j" class="data-row">
              <td class="side-cell" :style="{ minWidth: isEditingSide(j) ? '200px' : '' }">
                <div class="row-cell-inner" :style="{ minWidth: isEditingSide(j) ? '200px' : '' }">
                  <i class="el-icon-rank drag-handle" title="拖拽排序"></i>
                  <el-input
                    v-if="isEditingSide(j)"
                    v-model="s.Label"
                    size="mini"
                    @blur="endEditSide(j)"
                    @keyup.enter="endEditSide(j)"
                    @mousedown.native.stop
                    ref="sideInput" + j
                    autofocus
                  ></el-input>
                  <span v-else class="row-label" @click="startEditSide(j)">{{ s.Label }}</span>
                </div>
                <i class="el-icon-close row-del" @click.stop="delRow(j)" title="删除此行"></i>
              </td>
              <td class="side-code-cell">{{ s.Code }}</td>
              <td v-for="(h, i) in previewHeads" :key="'cell-'+j+'-'+i" class="data-col data-cell"></td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
      <div slot="footer" class="preview-footer">
        <el-button @click="previewDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="savePreview">保存修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  <script>
import Sortable from 'sortablejs';
export default {
  name: "KpiZuhe",
  props: ["kid", "pid"],
  data() {
    return {
      loading: false,
      clearLoading: false,
      keyword: "",

      valueQid: [],
      configs: [],
      qidcode: {},
      wei:"1",
      weiShow:false,
      options: [],
      optionsFil: [],
      
      // 图片预览相关
      imageDialogVisible: false,
      currentImage: '',

      // 组合表预览相关
      previewDialogVisible: false,
      previewHeads: [],
      previewSides: [],
      previewRow: null,
      saveLoading: false,
      rowSortable: null,
      colSortable: null,
      editingHeadIndex: -1,
      editingSideIndex: -1,
    };
  },
  watch: {
    keyword: {
      handler(val) {
        val = val.toLowerCase();
        this.optionsFil = this.options.filter((p) => {
          return p.label.toLowerCase().indexOf(val) !== -1;
        });
      },
    },
    valueQid(val) {
      if(val.length==0){
        this.wei ="1";
        this.weiShow=false;
        return;
      }
      let qid = val[0];
      if (this.qidcode[qid].Tpe!="multi"){
        return
      }
     this.weiShow=true
     
    },
  },
  methods: {
    startEditHead(index) {
      if (this.editingHeadIndex !== -1 && this.editingHeadIndex !== index) {
        this.endEditHead(this.editingHeadIndex);
      }
      this.editingHeadIndex = index;
      this.$nextTick(() => {
        const inputs = this.$refs['headInput' + index];
        if (inputs) {
          const inputEl = Array.isArray(inputs) ? inputs[0] : inputs;
          if (inputEl && inputEl.$el) {
            inputEl.$el.querySelector('input').focus();
          }
        }
      });
    },
    endEditHead(index) {
      if (this.editingHeadIndex === index) {
        this.editingHeadIndex = -1;
        this.$forceUpdate();
      }
    },
    isEditingHead(index) {
      return this.editingHeadIndex === index;
    },
    startEditSide(index) {
      if (this.editingSideIndex !== -1 && this.editingSideIndex !== index) {
        this.endEditSide(this.editingSideIndex);
      }
      this.editingSideIndex = index;
      this.$nextTick(() => {
        const inputs = this.$refs['sideInput' + index];
        if (inputs) {
          const inputEl = Array.isArray(inputs) ? inputs[0] : inputs;
          if (inputEl && inputEl.$el) {
            inputEl.$el.querySelector('input').focus();
          }
        }
      });
    },
    endEditSide(index) {
      if (this.editingSideIndex === index) {
        this.editingSideIndex = -1;
        this.$forceUpdate();
      }
    },
    isEditingSide(index) {
      return this.editingSideIndex === index;
    },
    cancelEdit() {
      if (this.editingHeadIndex !== -1 || this.editingSideIndex !== -1) {
        this.editingHeadIndex = -1;
        this.editingSideIndex = -1;
        this.$forceUpdate();
      }
    },
    getThumbnail(label) {
      return require(`@/assets/multi/multi-${label}.png`);
    },
    showImage(label) {
      this.currentImage = require(`@/assets/multi/multi-${label}.png`);
      this.imageDialogVisible = true;
    },
    getQid() {
      var api = this.COMMON.httpUrl + "qidSelect";
      var data = {
        pid: this.pid,
        kid: this.kid,
      };
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.configs = rs.data.cfg;
          let dt = rs.data.qids;
          let dd = [];
          for (let key of dt) {
            dd.push({ value: key.Qid, label: key.Qid+" "+key.Qlabel });
            this.qidcode[key.Qid] = key;
          }
          this.options = dd;
          this.optionsFil = dd;
        }
      });
    },
    selectAll() {
      this.valueQid = [];
      for (let v1 of this.optionsFil) {
        this.valueQid.push([v1.value]);
      }
    },
    add2() {
      alert(this.wei)
    },
    add() {
      if (this.valueQid.length == 0) {
        alert("请至少选取一个题目");
        return;
      }

      if (this.valueQid.length >= 2) {
        const allMulti = this.valueQid.every(qid => this.qidcode[qid].Tpe === 'multi');
        if (!allMulti) {
          alert('只有不同qid的多选题才可以同时勾选多个选项');
          return;
        }
      }
     
      let cfg = {};
      cfg["qid"] = this.valueQid.join(",");
      cfg["tpe"] = this.qidcode[this.valueQid[0]].Tpe;
      cfg["wei"] = this.wei;
      cfg["pid"] = this.pid;
      cfg["kid"] = this.kid;
      this.save(cfg);
    },
    save(cfg) {
      this.loading = true;
      var api = this.COMMON.httpUrl + "kpiZuheSave";
      var data = {
        kid: this.kid,
        pid: this.pid,
        cfg: cfg,
      };
      this.axios.post(api, data).then((response) => {
        this.loading = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.$message.success(rs.message);
          this.configs = rs.data;
          this.$refs.cascaderPanel.clearCheckedNodes()
          this.keyword = "";
          this.wei ="1";
          this.weiShow=false;
        }
      });
    },
    tagDel(index, id) {
      var api = this.COMMON.httpUrl + "kpiZuheDel";
      var data = {
        kid: this.kid,
        id: id,
      };
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.configs.splice(index, 1);
          this.$message.success(rs.message);
        }
      });
    },
    clearAll() {
      this.$confirm("确定清除全部已创建的组合表？此操作不可恢复。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.clearLoading = true;
        var api = this.COMMON.httpUrl + "kpiZuheClear";
        var data = { kid: this.kid };
        this.axios.post(api, data).then((response) => {
          this.clearLoading = false;
          var rs = response.data;
          if (rs.code) {
            this.$message.error(rs.message);
          } else {
            this.configs = [];
            this.$message.success(rs.message);
          }
        }).catch(() => {
          this.clearLoading = false;
        });
      }).catch(() => {});
    },
    preview(row) {
      try {
        this.previewHeads = typeof row.heads === 'string' ? JSON.parse(row.heads) : row.heads;
        this.previewSides = typeof row.sides === 'string' ? JSON.parse(row.sides) : row.sides;
        this.previewRow = row;
        this.editingHeadIndex = -1;
        this.editingSideIndex = -1;
        this.previewDialogVisible = true;
        this.$nextTick(() => {
          this.initRowSortable();
          this.initColSortable();
        });
      } catch (e) {
        this.$message.error('预览数据解析失败');
      }
    },
    initRowSortable() {
      if (this.rowSortable) { this.rowSortable.destroy(); }
      const tbody = this.$refs.previewTbody;
      if (!tbody) return;
      this.rowSortable = Sortable.create(tbody, {
        animation: 200,
        handle: '.drag-handle',
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        onEnd: (evt) => {
          if (evt.oldIndex === evt.newIndex) return;
          const parent = evt.from;
          parent.removeChild(evt.item);
          const ref = parent.children[evt.oldIndex] || null;
          parent.insertBefore(evt.item, ref);
          const item = this.previewSides.splice(evt.oldIndex, 1)[0];
          this.previewSides.splice(evt.newIndex, 0, item);
        },
      });
    },
    initColSortable() {
      if (this.colSortable) { this.colSortable.destroy(); }
      const headerRow = this.$refs.headerLabelRow;
      if (!headerRow) return;
      const fixedCount = 2;
      this.colSortable = Sortable.create(headerRow, {
        draggable: '.drag-col',
        handle: '.drag-handle',
        animation: 200,
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        onEnd: (evt) => {
          const realOld = evt.oldIndex - fixedCount;
          const realNew = evt.newIndex - fixedCount;
          if (realOld === realNew || realOld < 0 || realNew < 0) return;
          const parent = evt.from;
          parent.removeChild(evt.item);
          const ref = parent.children[evt.oldIndex] || null;
          parent.insertBefore(evt.item, ref);
          const item = this.previewHeads.splice(realOld, 1)[0];
          this.previewHeads.splice(realNew, 0, item);
        },
      });
    },
    delCol(index) {
      if (this.previewHeads.length <= 1) {
        this.$message.warning('至少保留一列');
        return;
      }
      this.previewHeads.splice(index, 1);
    },
    delRow(index) {
      if (this.previewSides.length <= 1) {
        this.$message.warning('至少保留一行');
        return;
      }
      this.previewSides.splice(index, 1);
    },
    savePreview() {
      this.saveLoading = true;
      var api = this.COMMON.httpUrl + "kpiZuheUpdate";
      var data = {
        pid: this.pid,
        kid: this.kid,
        id: this.previewRow.id,
        heads: JSON.stringify(this.previewHeads),
        sides: JSON.stringify(this.previewSides),
      };
      this.axios.post(api, data).then((response) => {
        this.saveLoading = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.$message.success(rs.message || '保存成功');
          this.previewRow.heads = JSON.stringify(this.previewHeads);
          this.previewRow.sides = JSON.stringify(this.previewSides);
        }
      });
    },
  },
  created() {
    localStorage.setItem("kpitag","six")
    this.getQid();
  },
};
</script>
  <style scoped>
#content {
  background-color: white;
  padding-top: 40px;
  padding-left: 50px;
}
.dleft {
  width: 550px;
}
.anl {
  margin-bottom: 20px;
}
/* v-deep深度选择器 */
:deep(.el-cascader-menu__wrap) {
  height: 350px;
}
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}
.tags {
  border: 2px dashed #e0e5f0;
  width: 550px;
  height: 550px;
  margin-left: 0px;
  margin-top: 20px;
  padding: 10px;
  overflow: auto;
}

.tags span {
  margin-left: 10px;
  margin-top: 10px;
}
.weizhi{
margin-top:25px;
}
.weizhi p{
  font-size:14px;
  color:rgb(175, 175, 175);
  padding:15px 0;
}

.radio-with-image {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.radio-with-image .el-radio {
  margin-left: 10px; /* 图片在前，选项在后，所以使用左边距 */
  flex-shrink: 0; /* 防止radio被压缩 */
}

.thumbnail {
  width: 40px;
  height: 40px;
  object-fit: contain;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 2px;
  vertical-align: middle;
}

.thumbnail:hover {
  opacity: 0.8;
  border-color: #409eff;
}

/* 优化单选按钮内部元素对齐 */
.el-radio__input {
  margin-right: 8px;
}

.el-radio__label {
  padding-left: 5px;
  line-height: normal;
}

/* 优化缩略图边距和视觉效果 */
.thumbnail-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px; /* 图片在前，选项在后，所以使用右边距 */
}

.thumbnail {
  transition: all 0.3s ease;
  box-sizing: border-box;
}

/* 改善选项之间的间距 */
.radio-with-image {
  margin-bottom: 18px;
  display: flex;
  align-items: center;
}

/* 优化带边框的 radio 样式 */
.el-radio.border {
  padding: 10px 15px;
  border-radius: 4px;
  min-height: 40px;
}

.dright {
  width: 650px;
}

:deep(.el-table .el-table__body-wrapper) {
  max-height: 550px;
  overflow-y: auto;
}

:deep(.el-table) {
  font-size: 13px;
}

:deep(.el-table th.el-table__cell) {
  background-color: #f5f7fa;
}

/* ========== 预览弹窗 ========== */
:deep(.el-dialog__body) {
  min-height: 60vh;
  padding: 16px 20px;
}

.preview-footer {
  text-align: right;
}

.preview-table-wrap {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 82vh;
}

.preview-table-center {
  min-width: 100%;
}

.preview-table {
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
  border: 1px solid #d8dce5;
  border-radius: 4px;
  min-width: 100%;
}

.preview-table th,
.preview-table td {
  border: 1px solid #dcdfe6;
  text-align: center;
  color: #303133;
  white-space: nowrap;
}

/* 固定左侧表头列 */
.preview-table .side-header {
  background-color: #ebeef5;
  color: #1f2d3d;
  font-weight: 600;
  padding: 10px 14px;
  min-width: 80px;
}

/* 数据列 */
.preview-table .data-col {
  max-width: 110px;
  min-width: 56px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 列表头第一行（Label + 操作） */
.preview-table .drag-col {
  background-color: #ebeef5;
  padding: 0;
  position: relative;
  transition: background-color 0.2s;
}

.preview-table .drag-col:hover {
  background-color: #d9ecff;
}

.preview-table .drag-col:hover .col-del {
  opacity: 1;
}

.col-header-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 10px 10px 6px;
}

.col-content {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  color: #1f2d3d;
  cursor: text;
}

.col-content:hover {
  background-color: #f5f7fa;
  border-radius: 2px;
}

/* 列表头第二行（Code） */
.preview-table .code-row {
  background-color: #f2f3f5;
  font-weight: 500;
  font-size: 12px;
  color: #48576a;
  padding: 6px 8px;
}

/* 数据行 */
.preview-table .data-row {
  transition: background-color 0.15s;
}

.preview-table .data-row:hover {
  background-color: #f5f7fa;
}

.preview-table .data-row:nth-child(even) {
  background-color: #fafbfc;
}

.preview-table .data-row:nth-child(even):hover {
  background-color: #f0f2f5;
}

/* 行左侧 Label 单元格 */
.side-cell {
  background-color: #ebeef5;
  padding: 0;
  font-weight: 500;
  color: #1f2d3d;
  position: relative;
}

.side-cell:hover .row-del {
  opacity: 1;
}

.row-cell-inner {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 8px 10px 8px 8px;
}

.row-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: text;
}

.row-label:hover {
  background-color: #f5f7fa;
  border-radius: 2px;
}

/* 行左侧 Code 单元格 */
.side-code-cell {
  background-color: #f2f3f5;
  font-size: 12px;
  color: #48576a;
  font-weight: 500;
  padding: 8px 10px;
}

/* 数据区空单元格 */
.data-cell {
  padding: 8px 10px;
  min-height: 32px;
}

/* ========== 拖拽手柄 ========== */
.drag-handle {
  cursor: grab;
  color: #b0b3b8;
  font-size: 12px;
  flex-shrink: 0;
  transition: color 0.2s;
}

.drag-handle:hover {
  color: #e6a23c;
}

.drag-handle:active {
  cursor: grabbing;
  color: #c78c30;
}

/* ========== 删除按钮 ========== */
.col-del {
  position: absolute;
  top: 1px;
  right: 1px;
  cursor: pointer;
  color: #fff;
  font-size: 11px;
  background: #c0c4cc;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  opacity: 0;
  transition: all 0.2s;
  z-index: 1;
}

.col-del:hover {
  background: #f56c6c;
  transform: scale(1.15);
}

.row-del {
  position: absolute;
  top: 1px;
  right: 1px;
  cursor: pointer;
  color: #fff;
  font-size: 11px;
  background: #c0c4cc;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  opacity: 0;
  transition: all 0.2s;
  z-index: 1;
}

.row-del:hover {
  background: #f56c6c;
  transform: scale(1.15);
}

/* ========== Sortable 拖拽状态 ========== */
.sortable-ghost {
  background-color: #ecf5ff !important;
  opacity: 0.6;
}

.sortable-chosen {
  background-color: #d9ecff !important;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

:deep(.el-input__inner) {
  padding: 6px 10px;
  font-size: 13px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  width: 200px;
}
:deep(.el-input__inner:focus) {
  border-color: #409eff;
}
</style>
 